module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"helpTranslate":"Hilf Central zu übersetzen"},"fr":{"helpTranslate":"Aider à traduire Central"}}')
  delete Component.options._Ctor
}
